import { resourcesCopy } from '@/copy/resources'
import { TextField } from '@/ui/Field/Field'
import { type FieldProps, type Fields, fieldStr } from './shared'

/** Shared by `web` and `mcp` — both expose only a URL. */
// eslint-disable-next-line react-refresh/only-export-components -- local component; the descriptor below is this file's only export
function UrlFields({ fields, set }: FieldProps) {
  return (
    <TextField
      id="res-url"
      label={resourcesCopy.forms.url.url}
      value={fields.url ?? ''}
      onValue={(v) => set('url', v)}
      inputProps={{ placeholder: resourcesCopy.forms.url.placeholder }}
    />
  )
}

/** `web` and `mcp` are identical (URL-only), so they share one descriptor. */
export const urlForm = {
  Fields: UrlFields,
  toBody: (f: Fields) => ({ url: f.url ?? '' }),
  fromResource: (d: unknown) => ({ url: fieldStr(d, 'url') }),
}
